import { compose } from 'recompose';
import { connect } from 'react-redux';

import HitsChart from '../../../../../components/Analytics/CannedCharts/HLECharts/HitsChart';
import { fetchMetricsData } from '../../../../../actions/metrics';
import {
  CHART_HLE_HITS,
  HISTORICAL_METRIC_30DAYS,
  HISTORICAL_METRIC_52WEEKS,
} from '../../../../../constants/charts';
import { API_BASED } from '../../../../../constants/metrics';
import {
  getChartData,
  getApiMap,
  getAppMap,
  getOrgMap,
  getIsChartLoading,
  getIsMetricTypeDataLoading,
} from '../../../../../reducers/metrics';

const defaulParams = {
  sortOrder: 'desc',
  sortBy: 'date',
  limit: [3],
  stats: [],
  timerange: 'week',
  buckets: ['apis'],
};
const metric = 'hits';

export const mapDispatchToProps = (dispatch) => ({
  fetchMetricsData: () =>
    dispatch(
      fetchMetricsData(
        CHART_HLE_HITS,
        defaulParams,
        metric,
        'by-day',
        API_BASED,
      ),
    ),
  fetchCustomDateMetricsData: (params) =>
    dispatch(
      fetchMetricsData(
        CHART_HLE_HITS,
        params,
        metric,
        params.aggregation,
        API_BASED,
      ),
    ),
});

export const mapStateToProps = (state) => ({
  defaultHitsResponse: getChartData(state, CHART_HLE_HITS),
  hitsResponseFor30DaysAgo:
    getChartData(
      state,
      CHART_HLE_HITS,
      HISTORICAL_METRIC_30DAYS,
    ),
  hitsResponseFor52WeeksAgo:
    getChartData(
      state,
      CHART_HLE_HITS,
      HISTORICAL_METRIC_52WEEKS,
    ),
  apiMap: getApiMap(state),
  appMap: getAppMap(state),
  orgMap: getOrgMap(state),
  isLoading: getIsChartLoading(state, CHART_HLE_HITS),
  is30DaysDataLoading: getIsMetricTypeDataLoading(
    state,
    CHART_HLE_HITS,
    HISTORICAL_METRIC_30DAYS,
  ),
  is52WeeksDataLoading: getIsMetricTypeDataLoading(
    state,
    CHART_HLE_HITS,
    HISTORICAL_METRIC_52WEEKS,
  ),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(HitsChart);
